module.exports = __webpack_public_path__ + "img/love-paws-homestay-swimming.1eb2bdbd.jpg";